var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfessionalTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 66,
    viewBox: "0 0 90 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.603 0.78418H3.25691C1.9433 0.78418 0.878418 1.84054 0.878418 3.14362V62.7166C0.878418 64.0196 1.9433 65.076 3.25691 65.076H86.603C87.9166 65.076 88.9815 64.0196 88.9815 62.7166V3.14362C88.9815 1.84054 87.9166 0.78418 86.603 0.78418Z",
    stroke: "#733FE7",
    strokeWidth: 0.830695,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.123 10.7471H54.222",
    stroke: "#733FE7",
    strokeWidth: 3.73813,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2076 10.7471H79.2104C79.9976 10.7471 80.7525 11.0573 81.3092 11.6095C81.8658 12.1617 82.1785 12.9106 82.1785 13.6915V53.9629C82.1785 54.7438 81.8658 55.4927 81.3092 56.0449C80.7525 56.5971 79.9976 56.9073 79.2104 56.9073H10.9623C10.1751 56.9073 9.42014 56.5971 8.8635 56.0449C8.30686 55.4927 7.99414 54.7438 7.99414 53.9629V13.6876C7.99414 12.9067 8.30686 12.1577 8.8635 11.6056C9.42014 11.0534 10.1751 10.7432 10.9623 10.7432H33.2612",
    stroke: "#733FE7",
    strokeWidth: 3.73813,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "0.21 4.18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.252 10.7471H35.3509",
    stroke: "#733FE7",
    strokeWidth: 3.73813,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7437 15.4292C47.3272 15.4292 49.4216 13.3516 49.4216 10.7888C49.4216 8.226 47.3272 6.14844 44.7437 6.14844C42.1603 6.14844 40.0659 8.226 40.0659 10.7888C40.0659 13.3516 42.1603 15.4292 44.7437 15.4292Z",
    fill: "#733FE7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3981 19.2818L44.7975 10.7627L39.7061 19.2818",
    stroke: "#733FE7",
    strokeWidth: 2.28441,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4448 26.2666H68.9303",
    stroke: "#733FE7",
    strokeWidth: 2.28441,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4448 32.0859H68.9303",
    stroke: "#733FE7",
    strokeWidth: 2.28441,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4448 37.6826H68.9303",
    stroke: "#733FE7",
    strokeWidth: 2.28441,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.063 47.2168H68.9308",
    stroke: "#733FE7",
    strokeWidth: 2.28441,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4448 47.2168H38.3126",
    stroke: "#733FE7",
    strokeWidth: 2.28441,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalTitle);
export default __webpack_public_path__ + "static/media/professional-title.9f2eccc7.svg";
export { ForwardRef as ReactComponent };